import { LinkCard } from "./LinkCard";
import { LinkCardGridProps } from "./LinkCard.types";

/** Link cards two to a row. */
export function LinkCardGrid({ items }: LinkCardGridProps) {
  return (
    <div className="row g-4">
      {items.map((item) => (
        <div className="col-12 col-lg-6" key={item.href || item.key}>
          <LinkCard item={item} />
        </div>
      ))}
    </div>
  );
}

export default LinkCardGrid;
